import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/FaqPage.css';
import { useLanguage } from '../i18n/LanguageContext';
import { CaretRightIcon } from '@phosphor-icons/react';

function FaqPage() {
    const { t } = useLanguage();
    const tuftingFaqs = t('faq.tuftingItems');
    const cardsFaqs = t('faq.cardsItems');
    const [openKey, setOpenKey] = useState(() => {
        if (tuftingFaqs?.length) {
            return 'tufting-0';
        }
        if (cardsFaqs?.length) {
            return 'cards-0';
        }
        return null;
    });

    const handleToggle = (key) => {
        setOpenKey((prev) => (prev === key ? null : key));
    };

    return (
        <div className='page faq-page'>
            <Header />
            <main>
                <section className='hero faq-hero'>
                    <div className='container hero-grid faq-hero-grid'>
                        <div className='hero-copy'>
                            <p className='eyebrow'>{t('faq.hero.eyebrow')}</p>
                            <h1>{t('faq.hero.title')}</h1>
                            <p className='lead'>
                                {t('faq.hero.lead')}
                            </p>
                            <div className='hero-actions'>
                                <Link className='button' to='/tufting'>
                                    {t('faq.actions.viewPieces')}
                                </Link>
                                <Link
                                    className='button button-secondary'
                                    to='/contact'
                                >
                                    {t('faq.actions.contact')}
                                </Link>
                            </div>
                        </div>
                        <div className='card faq-hero-card'>
                            <span className='chip'>
                                {t('faq.heroCard.chip')}
                            </span>
                            <h3>{t('faq.heroCard.title')}</h3>
                            <p>{t('faq.heroCard.note')}</p>
                            <Link className='text-link' to='/contact'>
                                {t('faq.heroCard.link')}
                            </Link>
                        </div>
                    </div>
                </section>

                <section className='section'>
                    <div className='container section-header'>
                        <div>
                            <p className='eyebrow'>{t('faq.list.eyebrow')}</p>
                            <h2>{t('faq.list.title')}</h2>
                        </div>
                        <p className='section-note'>
                            {t('faq.list.note')}
                        </p>
                    </div>
                    <div className='container faq-list'>
                        <div className='faq-group'>
                            <h3 className='faq-group-title'>
                                {t('faq.groups.tufting')}
                            </h3>
                            {tuftingFaqs.map((item, index) => {
                                const key = `tufting-${index}`;
                                const isOpen = openKey === key;

                                return (
                                    <div
                                        key={`${key}-${item.question}`}
                                        className={`card faq-item ${
                                            isOpen ? 'open' : ''
                                        }`}
                                    >
                                        <button
                                            type='button'
                                            className='faq-question'
                                            onClick={() => handleToggle(key)}
                                            aria-expanded={isOpen}
                                            aria-controls={`faq-panel-${key}`}
                                            id={`faq-control-${key}`}
                                        >
                                            <span>{item.question}</span>
                                            <span
                                                className='faq-icon'
                                                aria-hidden='true'
                                            >
                                                <CaretRightIcon
                                                    size={16}
                                                    weight='regular'
                                                />
                                            </span>
                                        </button>
                                        <div
                                            className='faq-answer'
                                            id={`faq-panel-${key}`}
                                            role='region'
                                            aria-labelledby={`faq-control-${key}`}
                                            aria-hidden={!isOpen}
                                        >
                                            <p>{item.answer}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className='faq-group'>
                            <h3 className='faq-group-title'>
                                {t('faq.groups.cards')}
                            </h3>
                            {cardsFaqs.map((item, index) => {
                                const key = `cards-${index}`;
                                const isOpen = openKey === key;

                                return (
                                    <div
                                        key={`${key}-${item.question}`}
                                        className={`card faq-item ${
                                            isOpen ? 'open' : ''
                                        }`}
                                    >
                                        <button
                                            type='button'
                                            className='faq-question'
                                            onClick={() => handleToggle(key)}
                                            aria-expanded={isOpen}
                                            aria-controls={`faq-panel-${key}`}
                                            id={`faq-control-${key}`}
                                        >
                                            <span>{item.question}</span>
                                            <span
                                                className='faq-icon'
                                                aria-hidden='true'
                                            >
                                                <CaretRightIcon
                                                    size={16}
                                                    weight='regular'
                                                />
                                            </span>
                                        </button>
                                        <div
                                            className='faq-answer'
                                            id={`faq-panel-${key}`}
                                            role='region'
                                            aria-labelledby={`faq-control-${key}`}
                                            aria-hidden={!isOpen}
                                        >
                                            <p>{item.answer}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>

                <section className='section'>
                    <div className='container cta-panel'>
                        <div>
                            <p className='eyebrow'>{t('faq.cta.eyebrow')}</p>
                            <h2>{t('faq.cta.title')}</h2>
                            <p>{t('faq.cta.note')}</p>
                        </div>
                        <Link className='button' to='/contact'>
                            {t('faq.cta.contact')}
                        </Link>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}

export default FaqPage;
